<script>
import {ref} from "vue";
import {useCallbackFormsStore} from "@js/store/CallbackFormsStore.js";
import {IMaskDirective} from 'vue-imask';
import SpinnerIndicator from "@js/components/Sections/Statuses/SpinnerIndicator.vue";
import CallbackErrorMessage from "@js/components/Sections/Callback/Components/CallbackErrorMessage.vue";
import IconX from "@js/components/Icons/IconX.vue";
import PrivacyPolicyAgreementLink from "@js/components/Sections/Contacts/Components/PrivacyPolicyAgreementLink.vue";

export default {
    name: "CallbackPopup",
    components: {PrivacyPolicyAgreementLink, IconX, CallbackErrorMessage, SpinnerIndicator},
    directives: {
        imask: IMaskDirective
    },
    data() {
        return {
            phoneMask: {
                mask: '+7 (000) 000-00-00',
            },
        }
    },
    methods: {
        updatePhone(newPhone) {
            this.callbackStore.popup_callback.data.phone = newPhone;
        },
    },
    setup() {
        const callbackStore = useCallbackFormsStore()
        const modalCallbackPopupRef = ref(null)

        const closeModal = () => {
            callbackStore.closeCallbackPopup()
        }

        const handleBackgroundClick = (event) => {
            if (!modalCallbackPopupRef.value.contains(event.target)) {
                closeModal()
            }
        }

        return {
            callbackStore,
            modalCallbackPopupRef,
            closeModal,
            handleBackgroundClick
        }
    },
}
</script>

<template>
    <div v-if="callbackStore.isPopupCallbackVisible"
         class="fixed inset-0 z-50 flex items-end sm:items-center justify-center  bg-black bg-opacity-70 transition-opacity "
         @click="handleBackgroundClick">
        <div ref="modalCallbackPopupRef"
             :class="{'top-i-0': callbackStore.isPopupCallbackVisible && callbackStore.popup_callback.animation_in_progress}"
             class="relative top-[100%] bg-transparent bg-white sm:bg-transparent sm:bg-[url('@img/callbacks/popup-circle-bg.svg')] bg-contain bg-no-repeat bg-center text-white rounded-tr-2xl rounded-tl-2xl sm:rounded-none shadow-lg max-h-[70%] sm:max-w-[800px] sm:max-h-[800px] w-full h-full p-6 md:p-10 transition-all duration-500">
            <button @click="closeModal"
                    class="absolute top-2 right-2 text-gray-400 hover:text-white focus:outline-none">
                <IconX
                    class="h-12 w-12 stroke-[#000] active:stroke-indigo-600 sm:stroke-white hover:sm:stroke-indigo-600 transition"/>
            </button>
            <div class="w-full h-full flex items-start sm:items-center justify-center pt-16 sm:pt-0">
                <div class="w-full max-w-sm mx-auto">
                    <p class="text-2xl text-[#2D2D2D] font-bold text-center mb-8">
                        Заполните короткую форму
                    </p>
                    <div>
                        <div class="relative z-0 w-full group">
                            <input type="tel"
                                   @keyup="updatePhone($event.target.value)"
                                   :value="callbackStore.popup_callback.data.phone"
                                   v-imask="phoneMask"
                                   name="ptf_phone" id="ptf_phone"
                                   class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"
                                   :class="[callbackStore.popup_callback.errors && callbackStore.popup_callback.errors['phone'] ? 'border-red-500' : '']"
                                   placeholder=" " required/>
                            <label for="ptf_phone"
                                   class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                                Номер телефона
                            </label>
                        </div>
                        <CallbackErrorMessage :error="callbackStore.popup_callback.errors"
                                              :error-msg="'phone'" class="psi-0"/>
                    </div>
                    <div class="mt-5">
                        <div class="relative z-0 w-full  group">
                            <input v-model="callbackStore.popup_callback.data.full_name" type="text"
                                   name="ptf_full_name" id="ptf_full_name"
                                   class="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-black appearance-none  focus:outline-none focus:ring-0 focus:border-indigo-600 peer"
                                   :class="[callbackStore.popup_callback.errors && callbackStore.popup_callback.errors['full_name'] ? 'border-red-500' : '']"
                                   placeholder=" " required/>
                            <label for="ptf_full_name"
                                   class="peer-focus:font-medium absolute text-sm text-gray-500 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:start-0  peer-focus:text-indigo-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6 left-0">
                                Как к вам обращаться?
                            </label>
                        </div>
                        <CallbackErrorMessage :error="callbackStore.popup_callback.errors"
                                              :error-msg="'full_name'" class="psi-0"/>
                    </div>
                    <div class="relative w-full lg:w-auto flex justify-center mt-10">
                        <button @click.prevent="callbackStore.sendPopupForm"
                                type="button"
                                class="flex justify-center items-center  text-white hover:text-indigo-600 border-2 border-indigo-600 bg-indigo-600 hover:bg-transparent font-medium rounded-full text-sm px-14 py-2.5 focus:outline-none transition">
                            <span class="text-base">
                                Заказать звонок
                            </span>
                            <SpinnerIndicator v-if="callbackStore.popup_callback.sending"
                                              class="w-6 h-6 ms-2"/>
                        </button>
                    </div>
                    <div class="mt-5 text-center">
                        <PrivacyPolicyAgreementLink/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.psi-0 {
    padding-left: 0 !important;
}

.top-i-0 {
    top: 0 !important;
}
</style>
